import { AllGooglePlaceTypes } from "@xapp/components";

// @xapp/stentor-templates, @xapp/stentor-handler-media relies on vm2 which causes setImmediate error
// So we redefine the types here

// export { ON_DEMAND_TEMPLATE, RADIO_TEMPLATE } from "@xapp/stentor-templates/lib/Types";
export const ON_DEMAND_TEMPLATE = "PODCAST_TEMPLATE";
export const RADIO_TEMPLATE = "RADIO_TEMPLATE";

export type TemplateType = "PODCAST_TEMPLATE" | "RADIO_TEMPLATE" | "CUSTOM";

// export { CUSTOM_TYPE } from "@xapp/stentor-templates/lib/Constants";
export const CUSTOM_TYPE = "CUSTOM";
export const OC_STUDIO_STARTER_TEMPLATE = "OC_STUDIO_STARTER_TEMPLATE";

// Custom Handler Types
export const CONVERSATION_HANDLER_TYPE = "ConversationHandler";
export const MULTIMEDIA_HANDLER_TYPE = "MultimediaHandlerType";
export const PLAY_LIVE_STREAM_HANDLER_TYPE = "PlayLiveStreamIntent";
export const PLAY_MEDIA_HANDLER_TYPE = "PlayMediaIntent";
export const PLAY_PODCAST_HANDLER_TYPE = "PlayPodcastIntent";

export const CONTACT_CAPTURE_HANDLER = "ContactCaptureHandler";
export const CONTACT_CAPTURE_HANDLER_TYPE = "ContactCaptureHandlerType";

export type TemplateId =
    | "business-coaching"
    | "consulting"
    //  | "financial-services"
    | "home-services-cleaning"
    | "home-services-contractors"
    | "home-services-outdoor"
    | "insurance"
    | "legal-services"
    //  | "life-coaching"
    //  | "real-estate"
    //  | "technology-services"
    //  | "travel"
    | "contact-capture";

export interface Template {
    /**
     * Name of the template
     */
    name: string;
    /**
     * App ID of the template
     */
    id: TemplateId | string;
    /**
     * Template description
     */
    description?: string;
    /**
     * URL to download the template, a JSON
     */
    url: string;
    /**
     * Optional list of Google business categories that this template is designed for.
     * This is used to help the user find the right template for their business
     */
    matches?: AllGooglePlaceTypes[];
}

export const TEMPLATE_IDS: TemplateId[] = [
    "business-coaching",
    "consulting",
    // "financial-services",
    "home-services-cleaning",
    "home-services-contractors",
    "home-services-outdoor",
    "insurance",
    "legal-services",
    //   "life-coaching",
    //   "real-estate",
    //   "technology-services",
    //   "travel",
    "contact-capture",
];

/**
 * Our small business templates
 */
export const TEMPLATES: Template[] = [
    {
        name: "Business Coaching",
        id: "business-coaching",
        description: "Business coaching, CEO coaching, mentorship",
        url: "https://templates.xapp.ai/business-coaching.json",
        matches: ["consultant"],
    },
    {
        name: "Consulting Services",
        id: "consulting",
        description: "Consulting Services",
        url: "https://templates.xapp.ai/consulting.json",
        matches: ["consultant"],
    },
    {
        name: "Cleaning Services",
        id: "home-services-cleaning",
        description: "Cleaning, pressure washing, window cleaning, carpet cleaning",
        url: "https://templates.xapp.ai/home-services-cleaning.json",
    },
    {
        name: "Janitorial Cleaning",
        id: "home-services-cleaning",
        url: "https://templates.xapp.ai/home-services-cleaning.json",
    },
    {
        name: "Window Cleaning",
        id: "home-services-cleaning",
        url: "https://templates.xapp.ai/home-services-cleaning.json",
    },
    {
        name: "General Contractors",
        id: "home-services-contractors",
        description: "HVAC, Plumbing, Roofing, General Contracting, Remodeling",
        url: "https://templates.xapp.ai/home-services-contractors.json",
        matches: ["general_contractor"],
    },
    {
        name: "HVAC",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Roofing",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
        matches: ["roofing_contractor"],
    },
    {
        name: "Exteriors",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Plumbing",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
        matches: ["plumber"],
    },
    {
        name: "Electrical",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
        matches: ["electrician"],
    },
    {
        name: "Painting",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
        matches: ["painter"],
    },
    {
        name: "Remodeling",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Renovations",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Handyman",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Flooring Contractor",
        id: "home-services-contractors",
        url: "https://templates.xapp.ai/home-services-contractors.json",
    },
    {
        name: "Landscaping & Outdoor Services",
        id: "home-services-outdoor",
        description: "Lawn care, gardening, landscaping, snow plowing, pressure washing, tree removal",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Lawn Care",
        id: "home-services-outdoor",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Tree Care",
        id: "home-services-outdoor",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Landscaping",
        id: "home-services-outdoor",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Snow Removal",
        id: "home-services-outdoor",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Pest Control",
        id: "home-services-outdoor",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Insurance",
        id: "insurance",
        description: "Insurance agents, brokers",
        url: "https://templates.xapp.ai/insurance.json",
        matches: ["insurance_agency"],
    },
    {
        name: "Legal Services",
        id: "legal-services",
        description: "Lawyers, tax attorneys, legal services",
        url: "https://templates.xapp.ai/legal-services.json",
        matches: ["lawyer"],
    },
    /**
    {
      name: "Life Coaching",
      id: "life-coaching",
      description: "Life coaches",
      url: "https://templates.xapp.ai/life-coaching.json"
    },
    {
      name: "Real Estate",
      id: "real-estate",
      description: "Real estate agents",
      url: "https://templates.xapp.ai/real-estate.json"
    },
    {
      name: "Technology Services",
      id: "technology-services",
      description: "Software development, IT services",
      url: "https://templates.xapp.ai/technology-services.json"
    },
    {
      name: "Travel",
      id: "travel",
      description: "Travel agents, brokers",
      url: "https://templates.xapp.ai/travel.json"
    }, */
    {
        name: "Junk Removal / Hauling",
        id: "contact-capture",
        description: "Junk removal, hauling, dumpster rental",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
    },
    {
        name: "Moving Services",
        id: "contact-capture",
        description: "Moving, storage, packing",
        url: "https://templates.xapp.ai/home-services-outdoor.json",
        matches: ["moving_company"],
    },
    {
        name: "Other",
        id: "contact-capture",
        description: "Non-specialized model, use if a more specific model isn't available.",
        url: "https://templates.xapp.ai/contact-capture.json",
        matches: ["point_of_interest"],
    },
];
